module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/main-visual-text-4103f59290201144398ac8b766c538d2.svg";